<div class="flex flex-col lg:flex-row gap-12 md:gap-6 w-full py-12">
  <div class="order-3 lg:order-none flex w-full lg:w-[25%] items-center justify-center px-2 lg:px-0 lg:pt-10">
    <app-advertisement-carousel class="w-full max-w-[420px] lg:max-w-[380px]"></app-advertisement-carousel>
  </div>

  <form class="order-1 lg:order-none flex flex-col flex-3 gap-10 lg:gap-8 items-center w-full lg:w-[50%] px-2 lg:px-12" #crearConsultaNgForm="ngForm" [formGroup]="crearConsultaForm">
    <div class="text-3xl text-pet-cli-color-3 font-bold">Agendar Cita</div>
    <div class="text-base text-pet-cli-color-3 font-normal mt-4">Seleccione la fecha y hora de la consulta</div>    
    <div class="flex flex-col gap-12 mt-3 sm:flex-row">
      <div class="rounded-xl bg-white p-4 shadow-xl w-full sm:w-1/2">
        <mat-calendar [(selected)]="selected" (selectedChange)="getHOrasOcupadasByFecha($event)" [minDate]="currentDate" ></mat-calendar>

      </div>
      <div class="flex flex-col items-center gap-3 w-full flex-wrap sm:w-1/2">
        <div class="text-pet-cli-color-3 text-xl font-bold">Hora de la cita</div>
        <div class="text-pet-cli-color-3 text-base font-normal">Seleccione una hora de la consulta</div>
        <div class="flex flex-wrap items-center justify-center" >
          <button *ngFor="let hora of horas; let i = index" class="px-4 py-2 border border-pet-cli-color-3 rounded w-2/5 m-1" [disabled]="hora.ocupada"
          [ngClass]="{
            'hover:bg-green-500': !hora.ocupada,
            'bg-gray-500': hora.ocupada,
            'bg-green-500': horaSelected === i
          }"
          (click)="crearConsultaForm.get('horaCita').setValue(hora.hora24) || horaSelected = i">
            {{ hora.hora }}
          </button>
        </div>
      </div>
    </div>
    <ng-container  *ngIf="(reagendar !== 'reschedule');">
    <div class="flex flex-col w-full items-center w-full">
      <div class="text-pet-cli-color-3 text-xl font-bold">Información de la Mascota</div>
      <div class="flex flex-col gap-5 w-auto items-center mt-5">
        <div class="flex gap-3 justify-between w-full">
          <select (change)="mascotaSelect($event.target.value)"
            class="w-[50%] bg-transparent h-10 border-2 border-pet-color-text-1 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-pet-color-text-1 block p-2.5 px-3">
            <option selected [value]="null">Seleccione una Mascota</option>
            <option *ngFor="let mascota of mascotasUsuario" [value]="mascota.idMascota" >{{mascota.nombreMascota}}</option>
          </select>
          <select (change)="atencionSelect($event.target.value)" [formControlName]="'idAtencion'"
            class="w-[50%] bg-transparent h-10 border-2 border-pet-color-text-1 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-pet-color-text-1 block p-2.5 px-3">
            <option selected [value]="null">Tipo de Atención</option>
            <option *ngFor="let item of atenciones" [value]="item.id">{{item.nombre}}</option>
          </select>
        </div>
        <div class="flex gap-3 justify-between w-full">
          <div class="w-[50%] text-pet-cli-color-3 font-bold">Suscripción</div>
          <input [disabled]="true" class="w-[50%] bg-transparent h-10 border-2 border-pet-color-text-1 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-pet-color-text-1 block  p-2.5 px-3"
           type="text" [value]="mascotaSelected?.nombreTarjeta || '-- --'">
        </div>
        <div class="flex gap-3 justify-between w-full">
          <div class="w-[50%] text-pet-cli-color-3 font-bold">Valor de la consulta</div>
          <input [disabled]="true" class="w-[50%] bg-transparent h-10 border-2 border-pet-color-text-1 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-pet-color-text-1 block  p-2.5 px-3"
           type="text" [value]="atencionSelected?.valor | currency:'COP'">
        </div>
      </div>
    </div>
  </ng-container>
    <div class="w-[70%] text-justify text-pet-cli-color-3 text-normal font-bold mt-5">
      El costo es de valor unico y no deberá realziar pagos extra en la veterinaria o centro de atención.
      Independiente que sea primera cita o reagendamiento.
    </div>
    
    <button *ngIf="reagendar === null" (click)="confirmDats()"
    class="text-white font-semibold bg-pet-cli-color-4 py-2 px-5 rounded w-full flex justify-start lg:w-auto lg:justify-center hover:bg-sky-500">
        Agendar Cita
    </button>
    <ng-container  *ngIf="(reagendar === 'reschedule');">
      <button (click)="solicitarReagendamiento()"
      class="text-white font-semibold bg-pet-cli-color-4 py-2 px-5 rounded w-full flex justify-start lg:w-auto lg:justify-center hover:bg-sky-500">
          Reagendar Cita
      </button>
    </ng-container>

  </form>
  <div class="order-2 lg:order-none flex w-full lg:w-[25%] mt-16 lg:mt-0">
    <app-publicy-cards></app-publicy-cards>
  </div>
</div>
